import React, { useState, useEffect } from 'react';
import { Box, Button, Typography, TextField, MenuItem, Paper, Grid } from '@mui/material';
import axios from '../../axiosInstance';
import { useNavigate } from 'react-router-dom';
import Profile from '../../components/Profile';
import Notification from '../../components/Notification';

const AddUserPage = () => {
  const [formData, setFormData] = useState({
    username: '',
    displayname: '',
    email: '',
    mobile: '',
    password: '',
    role: '',
  });
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post('https://backend.scholarkart.in/api/users', formData);
      navigate('/usermanagement');
    } catch (error) {
      console.error('Error creating user:', error);
    }
  };

  const handleSearch = async () => {
    try {
      const res = await axios.get(`https://backend.scholarkart.in/api/users/unassigned?query=${searchQuery}`);
      setSearchResults(res.data);
    } catch (error) {
      console.error('Error searching users:', error);
    }
  };

  const handleAssignUser = async (userId) => {
    try {
      const adminUser = JSON.parse(localStorage.getItem('user'));
      const token = localStorage.getItem('token');
      await axios.put('https://backend.scholarkart.in/api/users/assign-college', {
        userId,
        collegeId: adminUser.collegeId
      }, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      alert('User assigned successfully!');
      setSearchResults([]);
      setSearchQuery('');
    } catch (error) {
      console.error('Error assigning user:', error);
    }
  };

  return (
    <main className="flex-grow p-1">
    <div className="flex justify-between items-center relative bg-white p-4 rounded-lg shadow-md">

        <div className="relative w-full max-w-lg">

        </div>

      <div className="flex items-center space-x-4 relative">
        <Notification />
        <Profile />
      </div>
    </div>

      <Box p={4}>
        <Typography variant="h4" fontWeight="bold" mb={4}>Add New User</Typography>

        <Paper elevation={3} sx={{ padding: 3, marginBottom: 4 }}>
          <Typography variant="h6" mb={2}>Search and Assign Existing User</Typography>
          <Box display="flex" gap={2} mb={2}>
            <TextField
              fullWidth
              label="Search by Username, Email, or Mobile"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <Button variant="contained" onClick={handleSearch}>
              Search
            </Button>
          </Box>

          {searchResults.length > 0 && (
            <Box>
              {searchResults.map((user) => (
                <Paper key={user._id} sx={{ p: 2, mb: 2 }}>
                  <Typography><b>Username:</b> {user.username}</Typography>
                  <Typography><b>Email:</b> {user.email}</Typography>
                  <Typography><b>Mobile:</b> {user.mobile}</Typography>
                  <Button variant="outlined" sx={{ mt: 1 }} onClick={() => handleAssignUser(user._id)}>
                    Assign to My College
                  </Button>
                </Paper>
              ))}
            </Box>
          )}
        </Paper>

        <Paper elevation={3} sx={{ padding: 3 }}>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <TextField fullWidth label="Username" name="username" value={formData.username} onChange={handleChange} required />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField fullWidth label="Display Name" name="displayname" value={formData.displayname} onChange={handleChange} required />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField fullWidth label="Email" name="email" value={formData.email} onChange={handleChange} required />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField fullWidth label="Mobile" name="mobile" value={formData.mobile} onChange={handleChange} required />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField fullWidth label="Password" type="password" name="password" value={formData.password} onChange={handleChange} required />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField fullWidth select label="Role" name="role" value={formData.role} onChange={handleChange} required>
                  <MenuItem value="Student">Student</MenuItem>
                  <MenuItem value="Faculty">Faculty</MenuItem>
                  <MenuItem value="Librarian">Librarian</MenuItem>
                </TextField>
              </Grid>
            </Grid>

            <Button type="submit" variant="contained" color="primary" sx={{ mt: 3 }}>
              Create New User
            </Button>
          </form>
        </Paper>
      </Box>
    </main>
  );
};

export default AddUserPage;